<!--
/**
 * @copyright   OnlyOneProd © 2025
 * @authors     Jonathan COULLET <contact@onlyoneprod.com>
 * @link        https://onlyoneprod.com
 * @notice      All information contained herein is,
 *              and remains the property of OnlyOneProd and its suppliers,
 *              Any dissemination of this information or reproduction
 *              of this material is strictly forbidden unless prior
 *              written permission is obtained from OnlyOneProd.
 */
-->

<template>
    <section id="partners" class="screen">
        <CommonShapeAnimation shape="polygon" :sides="5" :rotation="10" position="right" />
        <div class="content">
            <div class="wrapper">
                <div class="intro">
                    <h2>Ils nous font confiance</h2>
                    <p><strong>Chaque projet est une rencontre, chaque réussite une histoire partagée.</strong></p>
                    <p>Parce que chaque marque mérite de briller, nous avons eu l’honneur d’accompagner ces entreprises
                        dans leurs projets. Leur confiance est notre plus grande fierté.</p>
                    <a id="partners-header-action" @click="clickHandler('contact')" title="Contactez-nous">
                        <CommonButton size="large" icon="next">Je me lance</CommonButton>
                    </a>
                </div>
                <div class="w-full">
                    <div class="panel grid-partners">
                        <a id="partners-backsoft" href="https://backsoft.fr" target="_blank">
                            <img src="@/assets/partenaires/backsoft.svg"
                                alt="BackSoft - Ingénierie et infrastructures réseau et systèmes" />
                        </a>
                        <a id="partners-bike-and-go" href="#" target="_blank">
                            <img src="@/assets/partenaires/bike-and-go.svg"
                                alt="Bike & Go - Location de trottinettes Et vélos électriques" />
                        </a>
                        <a id="partners-bys-kyt" href="#" target="_blank">
                            <img src="@/assets/partenaires/bys-and-kyt.svg" alt="Bys & Kyt - Agence digitale" />
                        </a>
                        <a id="partners-color-renovation" href="#" target="_blank">
                            <img src="@/assets/partenaires/color-renovation.svg"
                                alt="Color Rénovation - Menuiserie, serrurerie, stores" />
                        </a>
                        <a id="partners-dupuis" href="#" target="_blank">
                            <img src="@/assets/partenaires/dupuis-audit-expertise.svg"
                                alt="Dupuis Audit Expertise - Expertise comptable" />
                        </a>
                        <a id="partners-easy-parking" href="https://easy-parking.com" target="_blank">
                            <img src="@/assets/partenaires/easy-parking.svg"
                                alt="Easy Parking" />
                        </a>
                        <a id="partners-immo-confidences" href="#" target="_blank">
                            <img src="@/assets/partenaires/immo-confidences.svg" alt="Immo Confidences" />
                        </a>
                        <a id="partners-institut-ennour" href="https://en-nour.org/" target="_blank">
                            <img src="@/assets/partenaires/institut-nicois-ennour.svg" alt="Institut Niçois Ennour" />
                        </a>
                        <a id="partners-entre-deux" href="#" target="_blank">
                            <img src="@/assets/partenaires/l-entre-deux.svg" alt="L'entre deux" />
                        </a>
                        <a id="partners-mathilda-farache" href="https://mathildafarache.fr/" target="_blank">
                            <img src="@/assets/partenaires/mathilda-farache.svg" alt="Mathilda Farache - Sophrologue" />
                        </a>
                        <a id="partners-one-limousine" href="#" target="_blank">
                            <img src="@/assets/partenaires/one-limousine.svg" alt="One Limousine - Chaffeur privé" />
                        </a>
                        <a id="partners-planet-car-wash" href="https://planetcarwash.fr" target="_blank">
                            <img src="@/assets/partenaires/planet-car-wash.svg"
                                alt="Planet Car Wash - Le spécialiste du lavage auto écologique à Nice et dans les Alpes-Maritimes." />
                        </a>
                        <a id="partners-planet-clean-services" href="#" target="_blank">
                            <img src="@/assets/partenaires/planet-clean-services.svg" alt="" />
                        </a>
                        <a id="partners-platinium-driver" href="#" target="_blank">
                            <img src="@/assets/partenaires/platinium-driver.svg"
                                alt="Platinium Driver - Chaffeur privé" />
                        </a>
                        <a id="partners-plume" href="#" target="_blank">
                            <img src="@/assets/partenaires/plume.svg" alt="Plume - Relaxologie & Reïki" />
                        </a>
                        <a id="partners-association-thales" href="#" target="_blank">
                            <img src="@/assets/partenaires/thales.svg" alt="Association Thales" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import CommonShapeAnimation from "@/components/common/CommonShapeAnimation.vue";
import CommonButton from "@/components/common/CommonButton.vue";

import { trackButtonClick } from "@/helpers/analytics.helper";
import { scrollToSection } from "@/helpers/scroll.helper";

const clickHandler = (name: string) => {
    trackButtonClick(`partners-header-${name}`);
    scrollToSection(name);
}
</script>

<style lang="sass">
</style>